module.exports = __webpack_public_path__ + "assets/attach.42ba40f1.svg";